
<!-- Редактирование значения -->

<template>

	<div v-if="attr != null">

		<div v-if="attr != null && attr.type == 'bool'">

			<!-- Не работает инициализация значения после refresh
			<b-form-radio-group :value="value" v-on:change="input">

				<b-form-radio :value="true">Да</b-form-radio>
				<b-form-radio :value="false">Нет</b-form-radio>
				<b-form-radio :value="null">Нет (значение отсутствует)</b-form-radio>

			</b-form-radio-group>
			-->
			<v-select :value="value" :reduce="obj => obj.value" :options="bool_options" v-on:input="input" clearSearchOnSelect required appendToBody/>

		</div>

		<table_input v-else-if="attr != null && attr.type == 'number' && validation && validation[attr.key]"
			:validation="validation[attr.key]" :value="value" v-on:change="input" :item="{}" return_bad
		/>

		<div v-else-if="attr != null && attr.type == 'number'">

			<b-form-input :value="value" :disabled="attr == null" type="number" v-on:change="input"/>

		</div>

		<div v-else-if="attr != null && attr.type == 'date'">

			<date_picker :disabled="attr == null" :value="value" v-on:input="input"/>

		</div>

		<div v-else-if="attr != null && attr.type == 'time'">

			<b-form-timepicker :value="value" show-seconds :disabled="attr == null" v-on:change="input"/>

		</div>

		<div v-else-if="attr != null && attr.reference">

			<reference_values_select ref="reference_values" :value="value" :reference="attr.reference" v-on:input="input"/>

		</div>

		<div v-else>

			<b-form-input :value="value" :disabled="attr == null" v-on:change="input"/>

		</div>

	</div>

</template>

<script>

import reference_values_select from "./reference_values_select"
import date_picker from "../../widgets/date_picker"
import table_input from "../../widgets/table_input.vue"

export default
{
	props :
	{
		attr : Object,
		value : { default : () => null },
		validation : { type : Object, default : () => null }
	},

	components :
	{
		reference_values_select,
		date_picker,
		table_input
	},

	data()
	{
		return {

			bool_options :
			[
				{ label : "Да", value : true },
				{ label : "Нет", value : false },
				{ label : "Нет (значение отсутствует)", value : "clean" },
			]
			
		}
	},

	methods :
	{
		input(value)
		{
			if(this.attr.type == "number")
				value = ( value == null || value == "" ) ? null : Number(value)

			this.$emit("input", value)
		},
	}
}

</script>

